@file:OptIn(InternalResourceApi::class)

package mifos_mobile.core.ui.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String = "composeResources/mifos_mobile.core.ui.generated.resources/"

public val Res.drawable.core_ui_money_in: DrawableResource by lazy {
      DrawableResource("drawable:core_ui_money_in", setOf(
        ResourceItem(setOf(), "${MD}drawable/core_ui_money_in.png", -1, -1),
      ))
    }

public val Res.drawable.ic_icon_dashboard: DrawableResource by lazy {
      DrawableResource("drawable:ic_icon_dashboard", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_icon_dashboard.png", -1, -1),
      ))
    }

public val Res.drawable.ic_icon_error: DrawableResource by lazy {
      DrawableResource("drawable:ic_icon_error", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_icon_error.xml", -1, -1),
      ))
    }

public val Res.drawable.ic_icon_logo_1: DrawableResource by lazy {
      DrawableResource("drawable:ic_icon_logo_1", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_icon_logo_1.xml", -1, -1),
      ))
    }

public val Res.drawable.ic_icon_powered_logo: DrawableResource by lazy {
      DrawableResource("drawable:ic_icon_powered_logo", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_icon_powered_logo.xml", -1, -1),
      ))
    }

public val Res.drawable.ic_icon_success: DrawableResource by lazy {
      DrawableResource("drawable:ic_icon_success", setOf(
        ResourceItem(setOf(), "${MD}drawable/ic_icon_success.xml", -1, -1),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainDrawable0Resources(map: MutableMap<String, DrawableResource>) {
  map.put("core_ui_money_in", Res.drawable.core_ui_money_in)
  map.put("ic_icon_dashboard", Res.drawable.ic_icon_dashboard)
  map.put("ic_icon_error", Res.drawable.ic_icon_error)
  map.put("ic_icon_logo_1", Res.drawable.ic_icon_logo_1)
  map.put("ic_icon_powered_logo", Res.drawable.ic_icon_powered_logo)
  map.put("ic_icon_success", Res.drawable.ic_icon_success)
}
